import { makeActionCreator } from '../../config/store/utils'
import { getModalityYear } from '../../services/charts'

export const GET_PURCHASING_MECHANISMS = 'GET_PURCHASING_MECHANISMS'
export const GET_PURCHASING_MECHANISMS_ERROR = 'GET_PURCHASING_MECHANISMS_ERROR'
export const GET_PURCHASING_MECHANISMS_SUCCESS = 'GET_PURCHASING_MECHANISMS_SUCCESS'
export const onGetPurchasingMechanisms = makeActionCreator(GET_PURCHASING_MECHANISMS)
export const onGetPurchasingMechanismsError = makeActionCreator(GET_PURCHASING_MECHANISMS_ERROR, 'payload')
export const onGetPurchasingMechanismsSuccess = makeActionCreator(GET_PURCHASING_MECHANISMS_SUCCESS, 'payload')
export const onGetPurchasingMechanismsThunk = payload => async dispatch => {
  dispatch(onGetPurchasingMechanisms())

  try {
    const { data = {} } = await getModalityYear({ year: payload.year })
    const enhancedData = data.payload?.map(datum => ({
      amount: datum.amountCLP,
      amountUSD: datum.amountUSD,
      name: datum.modality,
      orders: datum.qtyOC,
      percentage: datum.percentage
    }))
    const categories = enhancedData.map(datum => datum.name)
    const csv = [
      ['Mecanismo de compra', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...enhancedData.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetPurchasingMechanismsSuccess({ categories, csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetPurchasingMechanismsError({ error }))
  }
}
